import { CoreUtils } from './Utils';
import { ApiUtils } from './Api';
import { TableSortUtils } from './TableSort';

export const Utils = {
  CoreUtils,
  ApiUtils,
  TableSortUtils,
};
